import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { ModalCadastroParceiroPrService } from './modal-cadastroppr.service';

@Component({
  selector: 'app-modal-cadastroppr',
  templateUrl: './modal-cadastroppr.component.html',
  styleUrls: ['./modal-cadastroppr.component.css']
})
export class ModalCadastroPrComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private modalParceiroPrService:ModalCadastroParceiroPrService) { }

  @Input() openModal:boolean;
  @Output() closeModal = new EventEmitter<any>();
  
  public model: FormGroup;
  public isLoading:boolean;
  public maskPhone;
  public maskCPF;
  public maskCNPJ;

  ngOnInit() {
    this.isLoading = false;
    this.maskPhone = ['(', /[0-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/,/\d/, /\d/, '-', /\d/, /\d/, /\d/,/\d/];
    this.maskCPF = [ /\d/, /\d/, /\d/,'.',/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/,'-', /\d/, /\d/];
    this.maskCNPJ = [ /\d/, /\d/, '.',/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/,'/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    this.model = this.formBuilder.group({
      tipo: new FormControl(1),
      nome: '',
      cpf: '',
      email:'',
      telefone:'',
      cidade:'',
      uf:'',
      pix:''
    });
  }

  closeModalEvent(){
    this.closeModal.emit();
  }

  AtualizaCheck(value){

   // console.log(value);
    this.model.get('tipo').setValue(value);

   // console.log(this.model.get('tipo').value);
  }

  submit(){
    if (this.model.invalid)
      return;

      this.isLoading = true;

      this.modalParceiroPrService.sendCadastro(
        this.model.get('nome').value,
        this.model.get('cpf').value,
        this.model.get('email').value,
        this.model.get('telefone').value,
        this.model.get('cidade').value,
        this.model.get('uf').value,
        this.model.get('pix').value,

      ).subscribe(
        sucesso =>{
          this.isLoading = false;
          alert("Seu cadastro foi enviado com sucesso! Dentro de 48 horas você receberá um email com seu código de parceiro.");
          this.closeModal.emit();
        },
        erro =>{
          this.isLoading = false;
          alert("Erro, verifique sua conexão com a internet e tente novamente mais tarde.");
           //this.closeModal.emit();
        }
      );
  }

}
